export const TIMEZONE_OPTIONS = [
  { value: 'America/New_York', label: 'New York' }, // Eastern (DST)
  { value: 'America/Chicago', label: 'Chicago' }, // Central (DST)
  { value: 'America/Denver', label: 'Denver' }, // Mountain (DST)
  { value: 'America/Phoenix', label: 'Phoenix' }, // Mountain (No DST)
  { value: 'America/Los_Angeles', label: 'Los Angeles' }, // Pacific (DST)
  { value: 'America/Anchorage', label: 'Anchorage' }, // Alaska (DST)
  { value: 'Pacific/Honolulu', label: 'Honolulu' }, // Hawaii (No DST)
  { value: 'America/Puerto_Rico', label: 'Puerto Rico' }, // Atlantic (No DST)
];

export const DAYS_OF_WEEK = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'] as const;
export type DayOfWeek = (typeof DAYS_OF_WEEK)[number];

export const DAYS_OF_WEEK_OPTIONS = DAYS_OF_WEEK.map((day) => ({
  label: day.toLowerCase().charAt(0).toUpperCase() + day.toLowerCase().slice(1),
  value: day,
}));
